import { AccountSectionType } from '@/components/AcountLayout';
import { Icon } from '@/components/Icon';
import { Link } from '@/components/Link';
import { Fragment } from 'react';
import styles from './Menu.module.scss';

type Props = {
  sections: AccountSectionType[];
};

export function Menu({ sections }: Props) {
  return (
    <nav className={styles.Menu}>
      {sections.map(({ title, icon, items }) => (
        <Fragment key={title}>
          <h3>
            <Icon icon={icon} /> {title}
          </h3>

          {items
            .filter((item) => !item.disabled)
            .map((item) => (
              <Link
                to={item.to}
                key={item.title}
                onClick={item.onClick}
                onMouseOver={item.prefetchQuery}
              >
                {item.title}{' '}
                {(item.unseenCount || 0) > 0 && <span>{item.unseenCount}</span>}
              </Link>
            ))}
        </Fragment>
      ))}
    </nav>
  );
}
